import React, { useRef, useEffect, useState } from "react";
import { MapContainer, Marker, TileLayer, Polyline, Tooltip, FeatureGroup, useMap, Polygon } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import Toast from "components/Toast";
import { MarkerMuster } from "react-leaflet-muster";
import "leaflet-imageoverlay-rotated";
import circle from "../../assets/markers/circle.png";
import yellowCircle from "../../assets/markers/yellowCircle.png"
import AntPathLayer from "./AntPathLayer";
import SpacesService from '../../api/spaces.service';
import TenantService from "../../api/tenant.service";

// Fix for missing default marker icons in Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

// Fit map to markers dynamically
const FitBounds = ({ bounds }) => {
    const map = useMap();
    useEffect(() => {
        if (bounds.isValid()) {
            map.fitBounds(bounds, { maxZoom: 5 });
        }
    }, [map, bounds]);
    return null;
};

export default function FloorplanPopup({ data, highlightRow, selectedRow }) {
    const listRef = useRef();
    const markerRef = useRef(null);
    const mapRef = useRef(null);
    const tenant = TenantService.getTenant()
    const [floorplanData, setFloorplanData] = useState([]);
    const [toastConfig, setToastConfig] = useState({
        isVisible: false,
        type: "info",
        message: "",
        displayTime: 5000,
    });

    useEffect(() => {
        getFloorplanImages()
    }, []);

    function anchorMarkers() {
        const myIcon = new L.icon({
            iconUrl: circle,
            iconSize: [10, 10],
            iconAnchor: [5, 5],
            popupAnchor: [0, -2],
        });

        // Filter and sort data
        const dataFiltered = data
            .filter(item => item.geo_coordinates)
            .sort((a, b) => new Date(a.time) - new Date(b.time));

        if (dataFiltered.length === 0) return null;

        const coordinates = dataFiltered.map(item => [item.geo_coordinates.x, item.geo_coordinates.y]); // Corrected order

        return (
            <FeatureGroup ref={markerRef}>
                {dataFiltered.map((anchor, i) => (
                    <Marker key={i} icon={myIcon} position={[anchor.geo_coordinates.x, anchor.geo_coordinates.y]} draggable={false}>
                        <Tooltip direction="top" offset={[-15, -12]} opacity={1}>
                            Time: {anchor.time}
                        </Tooltip>
                    </Marker>
                ))}
                <AntPathLayer positions={coordinates} />
            </FeatureGroup>
        );
    }

    function getFloorplanImages() {
        let images = []
        SpacesService.getSpaces(tenant).then((res) => {
            let resData = res.data.data
            if (resData.length === 0) {
                return
            }
            for (let i = 0; i < resData.length; i++) {
                if (resData[i].geoCoordinates !== null) {
                    let str = resData[i].geoCoordinates
                    const jsonCompatibleStr = str.replace(/\(/g, '[').replace(/\)/g, ']');
                    const geoArray = JSON.parse(jsonCompatibleStr);
                    // const corners = [
                    //     geoArray[1], // Top-left corner
                    //     geoArray[2], // Top-right corner
                    //     geoArray[0], // Bottom-left corner
                    // ];
                    const corners = geoArray
                    images.push({
                        id: resData[i].id,
                        geo: corners,
                        name: resData[i].name
                    })
                }
            }
        })
        setFloorplanData(images)
    }

    function getImages() {
        let images = floorplanData
        console.log("images",images)
        if (images.length === 0) {
            console.log("no images")
            return (
                <></>
            )
        } else {
            return (
                <>
                    {images.map((image, i) => (
                        <>
                        <Polygon positions={image.geo} fillColor={'#B51716'} color={'#B51716'} key={i}>

                        </Polygon>
                        <Marker key={image.geo[0][0]} position={image.geo[0]} draggable={false}>
                            <Tooltip direction="top" offset={[-15, -12]} opacity={1} permanent>
                                Space: {image.name}
                            </Tooltip>
                        </Marker>
                        </>
                    ))}
                </>
            )
        }
    }

    function showHovered() {
        var highlightIcon = new L.icon({
            iconUrl: yellowCircle,
            iconSize: [10, 10], // size of the icon
            iconAnchor: [5, 5], // point of the icon which will correspond to marker's location
            popupAnchor: [0, -2] // point from which the popup should open relative to the iconAnchor
        })
        if (selectedRow !== null && selectedRow !== undefined) {
            let hoveredCoordinates = [selectedRow.geo_coordinates.x, selectedRow.geo_coordinates.y]
            return (
                <>
                    <Marker key={hoveredCoordinates} icon={highlightIcon} position={hoveredCoordinates} draggable={false} ref={markerRef} zIndexOffset={1000}>
                        <Tooltip direction="top" offset={[0, 0]} opacity={1} permanent>
                            Selected Space
                        </Tooltip>
                    </Marker>
                </>
            )
        } else {
            return (
                <></>
            )
        }
    }

    function floorplanMap() {
        const dataFiltered = data.filter(item => item.geo_coordinates);
        const coordinates = dataFiltered.map(item => [item.geo_coordinates.x, item.geo_coordinates.y]); // Corrected order
        var bounds
        if (coordinates.length === 0) {
            bounds = L.latLngBounds([
                [50.505, -29.09],
                [52.505, 29.09],
            ])
        }
        else {
            bounds = L.latLngBounds(coordinates); // Dynamically compute bounds 
        }
            const ZoomToPoint = ({ lat, lng }) => {
                const map = useMap();
            
                useEffect(() => {
                    if (lat && lng) {
                        // map.flyTo([lat, lng], 15); // Adjust zoom level as needed
                        mapRef.current.setView([lat, lng], 15); // Adjust zoom level as needed
                    }
                }, [lat, lng, map]);
            
                return null;
            };
        return (

            <MapContainer
                id="map"
                bounds={bounds}
                style={{ height: "100%", width: "100%" }}
                whenCreated={(mapInstance) => (mapRef.current = mapInstance)}
            >
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution="&copy; OpenStreetMap contributors"
                    maxZoom={19}
                />
                {anchorMarkers()}
                {getImages()}
                {showHovered()}
                <FitBounds bounds={bounds} />
                {selectedRow && <ZoomToPoint lat={selectedRow.geo_coordinates.x} lng={selectedRow.geo_coordinates.y} />}
            </MapContainer>

        );
    }

    if (data.length !== 0) {
        return (
            <>
                <Toast setParentToastConfig={setToastConfig} toastBody={toastConfig} />
                <div style={{ height: "100%", width: "100%" }} ref={listRef}>
                    {floorplanMap()}
                </div>
            </>
        );

    } else {
        return (
            <></>
        )
    }
}